import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { monthNamesShort } from 'utils/dateFormat';
import Spinner from '../common/Spinner';
import Maybe from '../common/Maybe';
import useDashboardMetrics from 'hooks/useDashboardMetrics';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const MonthlyBalanceGraph = ({ chartData }) => {
    // const currentMonth = new Date().getMonth();
    // const filteredChartData = chartData?.filter((_, index) => index <= currentMonth);
    // const labels = monthNamesShort.slice(0, currentMonth + 1).map(el => el.toUpperCase());
    const sortedData = chartData?.sort((a, b) => monthNamesShort.indexOf(a.period) - monthNamesShort.indexOf(b.period));

    const options = {
        plugins: {
            legend: {
                display: false,
                labels: {
                    boxWidth: 8,
                    boxHeight: 8,
                }
            },
            title: {
                display: false,
                text: 'Total Monthly Balance',
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                grid: {
                    display: false,
                    drawBorder: false
                },
            },

            y: {
                beginAtZero: true,
                stacked: true,
                ticks: {
                    display: false,
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                    borderDash: [5, 5],
                    display: false,
                    drawBorder: false
                }
            },
        },
    };

    const data = {
        labels: sortedData?.map(item => item?.period),
        datasets: [
            {
                label: 'Total Balance',
                data: sortedData?.map((item => item?.balance / 100)),
                borderColor: '#398D94',
                backgroundColor: 'rgba(57, 140, 148, 0.1)',
                pointBackgroundColor: '#398D94',
                pointBorderColor: '#fff',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#398D94',
                fill: true,
                tension: 0.4,
            },
        ],
    };


    const addGradient = (canvas) => {
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, 0, 220);
        gradient.addColorStop(0, "rgba(0,83,92,0.35");
        gradient.addColorStop(1, "rgba(233, 238, 238, 0.669");

        return {
            ...data,
            datasets: [
                {
                    ...data.datasets[0],
                    backgroundColor: gradient,
                }
            ],
        }
    }

    return (
        <>
            {/* <Maybe condition={loading}>
                <Spinner />
            </Maybe> */}

            {/* <Maybe condition={!loading}> */}
                <div className="w-full flex items-center flex-wrap lg:flex-nowrap" style={{height: "95px"}}>
                    <Line data={addGradient} options={options} />
                </div>
            {/* </Maybe> */}
        </>
        )
}

export default MonthlyBalanceGraph